// extracted by mini-css-extract-plugin
module.exports = {"Buttons":"auth_Buttons__3JAj_","Content":"auth_Content__IZP2o","Change":"auth_Change__a7rXz","Error":"auth_Error__allcx"};